export default "__VITE_ASSET__BJ6WCXzS__"